module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/strong_point/5_33e240cdf4521a1143947a1d9639cfc6.png";